import { Dialog } from '@mui/material';

import { Cpg } from '@occc/graphql';

import { SubmissionGroupAddLocationsTableController } from './submission-group-locations-table/submission-group-add-locations-table.controller';

type SubmissionGroupsAddLocationsDialogProps = {
  cpg: Cpg;
  open: boolean;
  setDialogOpen: (open: boolean) => void;
  onSubmit: (bulkSelectedItems: Set<string>) => void;
  isUpdatingLocations?: boolean;
};

export const SubmissionGroupAddLocationsDialog = ({
  cpg,
  open,
  setDialogOpen,
  onSubmit,
  isUpdatingLocations = false,
}: SubmissionGroupsAddLocationsDialogProps) => {
  const onClose = () => {
    if (!isUpdatingLocations) {
      setDialogOpen(false);
    }
  };

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <SubmissionGroupAddLocationsTableController
        cpg={cpg}
        onSubmit={onSubmit}
        isUpdatingLocations={isUpdatingLocations}
      />
    </Dialog>
  );
};
